/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RandomOrder = {
    type: RandomOrder.type;
};
export namespace RandomOrder {
    export enum type {
        RANDOM = 'random',
    }
}

